var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCarExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.1 9.02h-7.19a2.1 2.1 0 0 0-1.97 1.4l-2.89 8.32v11.1c0 .77.63 1.39 1.4 1.39h1.38a1.4 1.4 0 0 0 1.39-1.39v-1.39h7.89v-2.77H8.83v-6.01c0-.52.42-.93.93-.93h8.35v-2.62H9.9l1.5-4.32h6.7V9.02ZM28.6 24.3l4.9-5.14 1.7-1.77-1.7-1.77-4.9-5.13-1.7 1.77 3.72 3.89h-9.08v2.5h9.08l-3.72 3.88 1.7 1.77Zm-17.34-3.24a.93.93 0 0 0-.93.92v.44c0 .5.41.93.93.93h1.47c.51 0 .93-.42.93-.93v-.44a.93.93 0 0 0-.93-.92h-1.47Z",
    clipRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarExit);
export default __webpack_public_path__ + "static/media/car-exit.6495e4a3.svg";
export { ForwardRef as ReactComponent };